/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spacer, ExpandCollapse, Typography } from '@telus-uds/components-web';
import { Box } from '../design/css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import {
  PROVINCE_MULTISELECT_OPTIONS,
  renderDashboardMultiSelectRows,
  renderDashboardDualDateRangeFilters
} from './components';

const VULFilters = ({
  data,
  updateFilters,
  onApplyFilters,
  onResetFilters,
  filterState,
  staticLabels,
  hiddenFilters = [],
  dealershipNames = [],
  filterByDealership
}) => {
  const {
    startDate,
    endDate,
    completedStartDate,
    completedEndDate,
    channelId,
    province,
    productId,
    status,
    submitter,
    isVulcanOrder,
    dealership
  } = filterState;
  const {
    filterByChannel,
    filterByProvince,
    filterByProducts,
    filterByStatus,
    filterBySubmitter,
    filterByVulcanOrders,
    filterByOpenedDates,
    filterByValidationDates,
    startDateLabel,
    endDateLabel,
    buttonApply,
    buttonReset,
    filtersDropdownTitle
  } = staticLabels;
  const { channels, products, statuses, submitters, vulcanOrders } = data;
  const channelList =
    channels &&
    channels.map(channel => ({ label: channel.text, value: channel.value }));
  const productList =
    productId &&
    products.map(product => ({ label: product.text, value: product.value }));
  const statusList =
    statuses &&
    statuses.map(statusdata => ({
      label: statusdata.text,
      value: statusdata.value
    }));

  const multiSelectFilters = [
    {
      label: filterByProvince,
      name: 'province',
      options: PROVINCE_MULTISELECT_OPTIONS,
      value: province
    },
    {
      label: filterByChannel,
      name: 'channelId',
      options: channelList,
      value: channelId
    },
    {
      label: filterByProducts,
      name: 'productId',
      options: productList,
      value: productId
    },
    {
      label: filterByStatus,
      name: 'status',
      options: statusList,
      value: status
    },
    {
      label: filterBySubmitter,
      name: 'submitter',
      options: (submitters || []).map(op => ({
        value: op.id,
        label: `${op.firstName} ${op.lastName}`
      })),
      value: submitter
    },
    {
      label: filterByVulcanOrders,
      name: 'isVulcanOrder',
      options: vulcanOrders,
      value: isVulcanOrder
    },
    ...(filterByDealership && dealershipNames.length > 0
      ? [{
          label: filterByDealership,
          name: 'dealership',
          options: dealershipNames.map(n => ({ value: n, label: n })),
          value: dealership,
          multiSelect: false
        }]
      : []),
  ];

  hiddenFilters.forEach(filter => {
    multiSelectFilters.splice(multiSelectFilters.findIndex(f => f.name === filter), 1);
  });

  return (
    <ExpandCollapse initialOpen={[]}>
      {(expandProps) => (
        <ExpandCollapse.Panel
          {...expandProps}
          panelId="filters"
          control={<Typography variant={{ bold: true }}>{filtersDropdownTitle}</Typography>}
        >
          <div className="row">
            {renderDashboardDualDateRangeFilters({
              updateFilters,
              filterByOpenedDates,
              filterByValidationDates,
              startDateLabel,
              endDateLabel,
              startDate,
              endDate,
              completedStartDate,
              completedEndDate
            })}
            {renderDashboardMultiSelectRows(multiSelectFilters, updateFilters)}
          </div>

          <Spacer space={3} />
          <Box display="flex" justifyContent="center" flexDirection="row">
            <Button onClick={onApplyFilters} variant={{ priority: 'low' }}>
              {buttonApply}
            </Button>
            <Box width="2"> </Box>
            <Button onClick={onResetFilters}>{buttonReset}</Button>
          </Box>
        </ExpandCollapse.Panel>
      )}
    </ExpandCollapse>
  );
};

export default VULFilters;

VULFilters.propTypes = {
  staticLabels: PropTypes.object.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterState: PropTypes.shape({
    filterStatus: PropTypes.string,
    startDate: PropTypes.dateFormat,
    endDate: PropTypes.dateFormat,
    completedStartDate: PropTypes.dateFormat,
    completedEndDate: PropTypes.dateFormat,
    submitter: PropTypes.array,
    isVulcanOrder: PropTypes.string,
    status: PropTypes.array,
    channelId: PropTypes.array,
    province: PropTypes.array,
    productId: PropTypes.array
  }).isRequired,
  hiddenFilters: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};
